(function () {
  function getTimePartsInTZ(tz) {
    const dtf = new Intl.DateTimeFormat('en-AU', {
      timeZone: tz,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });

    const parts = dtf.formatToParts(new Date());
    const map = {};
    for (const p of parts) {
      if (p.type !== 'literal') map[p.type] = p.value;
    }
    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute)
    };
  }

  function minutesSinceMidnight(t) {
    return (t.hour * 60) + t.minute;
  }

  function diffMinutesSydneyVsBrisbane() {
    const syd = getTimePartsInTZ('Australia/Sydney');
    const bne = getTimePartsInTZ('Australia/Brisbane');

    const sydKey = (syd.year * 372) + (syd.month * 31) + syd.day;
    const bneKey = (bne.year * 372) + (bne.month * 31) + bne.day;

    const sydMinutes = minutesSinceMidnight(syd) + (sydKey * 1440);
    const bneMinutes = minutesSinceMidnight(bne) + (bneKey * 1440);

    return sydMinutes - bneMinutes;
  }

  function isLikelyQLD() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    return tz === 'Australia/Brisbane';
  }

  function shouldShowDSTWarning() {
    if (!isLikelyQLD()) return false;
    return diffMinutesSydneyVsBrisbane() === 60;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const guard = document.getElementById('rezdy-click-guard');
    const backdrop = document.getElementById('tz-modal-backdrop');
    const btnConfirm = document.getElementById('tz-modal-confirm');
    const btnCancel = document.getElementById('tz-modal-cancel');

    if (!guard || !backdrop || !btnConfirm || !btnCancel) return;

    let acknowledged = false;
    const needsWarning = shouldShowDSTWarning();


    function openModal() {
      backdrop.classList.add('is-open');
      backdrop.setAttribute('aria-hidden', 'false');
      btnConfirm.focus({ preventScroll: true });
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      backdrop.classList.remove('is-open');
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function enableGuard() {
      guard.classList.add('is-on');
      guard.setAttribute('aria-hidden', 'false');
    }

    function disableGuard() {
      guard.classList.remove('is-on');
      guard.setAttribute('aria-hidden', 'true');
    }

    if (!needsWarning) {
      disableGuard();
      return;
    }

    enableGuard();

    guard.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!acknowledged) openModal();
    }, true);

    btnConfirm.addEventListener('click', function () {
      acknowledged = true;
      closeModal();
      disableGuard();
    });

    btnCancel.addEventListener('click', function () {
      closeModal();
      enableGuard();
    });
  });
})();
